import React from 'react';

import { Redirect, Switch } from 'react-router-dom';

import Route from './route';
import {
  NotFound,
  Home as PharmacistHome,
  Profile,
  ValidateHome,
} from '~/modules/pharmacist/pages';
import { Home as PatientHome } from '~/modules/patient/pages';

export default function Routes() {
  return (
    <Switch>
      <Route exact path="/">
        <Redirect to="/receita" />
      </Route>

      <Route path="/receita/perfil" component={Profile} />
      <Route path="/p/:id" exact component={PatientHome} />
      <Route path="/receita" exact component={PharmacistHome} />
      <Route path="/receita/:id" exact component={PharmacistHome} />

      <Route path="/valida" exact component={ValidateHome} />
      <Route path="/valida/:id" exact component={ValidateHome} />

      <Route path="/404" exact component={NotFound} />

      <Route path="*" component={NotFound} />
    </Switch>
  );
}
